import { render, staticRenderFns } from "./a-product-period-setting.vue?vue&type=template&id=5eb3acba&scoped=true&"
import script from "./a-product-period-setting.vue?vue&type=script&lang=js&"
export * from "./a-product-period-setting.vue?vue&type=script&lang=js&"
import style0 from "./a-product-period-setting.vue?vue&type=style&index=0&id=5eb3acba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3acba",
  null
  
)

export default component.exports